import { type ReactNode } from 'react'
import { type Minutes } from '@terros/common'
import { SizePrimitives, formatTimeRange } from '@front/model'
import { TButton } from '../../buttons'

type TimeslotButtonProps = {
  startMinutes: Minutes
  duration: Minutes
  isSelected: boolean
  onToggle: () => void
}

export const TimeslotButton = ({ startMinutes, duration, isSelected, onToggle }: TimeslotButtonProps): ReactNode => {
  return (
    <TButton
      variant={isSelected ? 'primary' : 'gray'}
      size='small'
      onClick={onToggle}
      noTranslation
      style={{ minWidth: SizePrimitives['32'] }}
    >
      {formatTimeRange(startMinutes, duration)}
    </TButton>
  )
}
